import React from 'react';
import { Loader2 } from 'lucide-react';

const VARIANTS = ['primary', 'success', 'info', 'warning', 'danger', 'neutral'];

/**
 * Bouton Orakle Weather — Design System unifié
 *
 * @param {object} props
 * @param {'primary'|'success'|'info'|'warning'|'danger'|'neutral'} [props.variant]
 * @param {'md'|'sm'|'icon'} [props.size]
 * @param {boolean} [props.emphasis] — CTA principal (bordure 2px, ombre légère)
 * @param {import('lucide-react').LucideIcon} [props.icon]
 * @param {boolean} [props.loading]
 * @param {boolean} [props.fullWidth]
 */
const Button = React.forwardRef(({
    variant = 'primary',
    size = 'md',
    emphasis = false,
    icon: Icon,
    children,
    loading = false,
    disabled = false,
    fullWidth = false,
    type = 'button',
    className = '',
    ...props
}, ref) => {
    const safeVariant = VARIANTS.includes(variant) ? variant : 'primary';

    return (
        <button
            ref={ref}
            type={type}
            className={[
                'orakle-btn',
                `orakle-btn--${safeVariant}`,
                size !== 'md' && `orakle-btn--${size}`,
                emphasis && 'orakle-btn--emphasis',
                fullWidth && 'orakle-btn--full',
                className,
            ].filter(Boolean).join(' ')}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            {...props}
        >
            {loading ? (
                <Loader2 className="orakle-btn__icon orakle-btn__spinner" aria-hidden />
            ) : Icon ? (
                <Icon className="orakle-btn__icon" aria-hidden />
            ) : null}
            {children != null && children !== '' && (
                <span className="orakle-btn__label">{children}</span>
            )}
        </button>
    );
});

Button.displayName = 'Button';

export default Button;
